module.exports = __webpack_public_path__ + "static/media/2DGACM4.7d488442.jpg";